"use client";

import { useEffect, useRef } from "react";

export const WIDGET_CONTAINER_ID = "quote-widget";

/**
 * Injects the quote vendor's own widget script exactly as its embed contract
 * specifies: <script id="strife" src={scriptSrc} {...attributes}
 * data-strife-container-id={container}> rendering into the container div.
 * Shared by the agent portal launcher and the public consumer quote page.
 */
export function WidgetEmbed({
  scriptSrc,
  attributes,
  containerAttribute,
}: {
  scriptSrc: string;
  attributes: Record<string, string>;
  containerAttribute: string;
}) {
  const injected = useRef(false);

  useEffect(() => {
    if (injected.current) return;
    injected.current = true;
    const script = document.createElement("script");
    script.id = "strife";
    script.src = scriptSrc;
    for (const [name, value] of Object.entries(attributes)) {
      script.setAttribute(name, value);
    }
    script.setAttribute(containerAttribute, WIDGET_CONTAINER_ID);
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, [scriptSrc, attributes, containerAttribute]);

  return (
    <div
      id={WIDGET_CONTAINER_ID}
      className="mt-4 min-h-[600px] rounded-md border border-line bg-white"
    />
  );
}
